import React from "react";
import { TextField, Typography, Box, InputAdornment, Button } from "@mui/material";
import { FormikProps } from "formik";
import { BusinessFormProps } from "../types/business-form";

interface DynamicInputProps {
  formik: FormikProps<BusinessFormProps>;
  name: keyof BusinessFormProps;
  label: string;
  type: string;
  placeholder?: string;
  helperText?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  adornment?: {
    text: string;
    onClick: () => void;
  };
  value?: string;
  disabled?: boolean;
  secondaryText?: string;
}

const DynamicInput: React.FC<DynamicInputProps> = ({
  formik,
  name,
  label,
  type,
  placeholder,
  helperText,
  inputProps,
  adornment,
  value,
  disabled,
  secondaryText
}) => {
  return (
    <Box display="flex" flexDirection="column" sx={{ width: { xs: "100%", lg: "50%" } }} mt={1}>
      <Typography variant="h6" mb={1}
       sx={{
        color:"#474747",
        fontFamily: "Maven Pro, sans-serif",
        fontSize: "20px",
        fontWeight: 500, 
        lineHeight: "30px", 
        textAlign: "left", 
        textUnderlinePosition: "from-font", 
        textDecorationSkipInk: "none", 
      }}
      >
        {label} <Typography variant="body2" sx={{ color: "text.primary",display:'inline' }}>{secondaryText}</Typography>
      </Typography>
      <TextField
        name={name}
        type={type}
        placeholder={placeholder}
        value={value ?? formik.values[name]}
        disabled={disabled ?? Boolean(value)} 
        onChange={(e) => {
          let value = e.target.value;
          if (type === "text" && inputProps?.pattern) {
            const regex = new RegExp(inputProps.pattern);
            if (!regex.test(value)) value = value.replace(/[^0-9]/g, "");
          }
          formik.setFieldValue(name, value);
        }}
        onBlur={formik.handleBlur}
        error={Boolean(formik.touched[name] && formik.errors[name])}
        helperText={
          formik.touched[name] && formik.errors[name]
            ? formik.errors[name]
            : helperText || ""
        }
        // inputProps={inputProps}
        sx={{
          fieldset: {
            borderColor: "#DADADA", // Default border color
          },
          width: { xs: "100%", lg: "100%" } 
        
        }}
        InputProps={{
            endAdornment: adornment && (
              <InputAdornment position="end">
                <Typography onClick={adornment.onClick}
                 className="custom-button" color="text.secondary">
                  {adornment.text}
                </Typography>
              </InputAdornment>
            ),
          }}
      />
    </Box>
  );
};

export default DynamicInput;